import { MprcFilterCountText } from "components/filter/MprcFilterCountText";
import { MprcFilterNoRecords } from "components/filter/MprcFilterNoRecords";
import { useMprcTheme } from "components/MprcThemeProvider";
import * as React from "react";

interface IProps {
    loading: boolean;
    isEmpty: boolean;
    countText: string;
    filter?: {
        active: boolean;
        text: string;
        resetText?: string;
        additionalInfo?: React.ReactNode;
        onResetFilter?: () => void;
    };
}

export const MprcFilterCount: React.FC<IProps> = ({ loading, isEmpty, countText, filter }) => {
    const { theme } = useMprcTheme();

    return loading
        ? null
        : isEmpty
            ? <MprcFilterNoRecords
                filtered={filter?.active ?? false}
                message={filter && filter.active ? (filter.text ?? countText) : countText}
                resetFilterText={filter?.resetText ?? theme.MprcFilterCount.resetFilterText}
                onResetFilter={filter?.onResetFilter}
            />
            : <MprcFilterCountText
                variant={filter?.active ? "bodyNotice" : "caption"}
                text={filter && filter.active ? (filter.text ?? countText) : countText}
                additionalInfo={filter && filter.active ? filter?.additionalInfo : undefined}
                resetFilterText={filter && filter.active ? (filter.resetText ?? theme.MprcFilterCount.resetFilterText) : undefined}
                onResetFilter={filter && filter.active ? filter?.onResetFilter : undefined}
            />;
};
